<template>
     <confirm-dialog @confirmed="remove">
     <template slot="header">Ausstattung löschen</template>
      <template slot="question">Soll das Ausstattung <span class="font-bold">{{ attribute.name }}</span> wirklich gelöscht werden?</template>
      <template slot="confirm"><button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Ausstattung löschen</button-delete></template>
      <button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Ausstattung löschen</button-delete>
      </confirm-dialog>
</template>

<script>
import ButtonDelete from "../UI/ButtonDelete.vue";
import ConfirmDialog from "../UI/ConfirmDialog.vue";



export default {
    name: "AttributeDelete",
    components: {ConfirmDialog, ButtonDelete},
    props: ['attribute'],

    methods: {

        remove() {
            this.$http
                .post('/admin/attributes/' + this.attribute.id, {
                    _method: 'delete',
                })
                .then(() => {

                    this.showModal = false;
                    this.$emit('updated');
                    this.$root.$emit('alert', this.attribute.name + ' wurde gelöscht.');
                    this.$emit('leaveModal');
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        }
    }

}


</script>


<style scoped>

</style>